import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Context/Handlers/LoadSettings";

export type HandlerType = Parameters<typeof RequestDataFromApi>[0];

addToChainAfter(chain, RequestDataFromApi, ParseInvoiceCreditCardData);

function ParseInvoiceCreditCardData(props: HandlerType) {
    const settingsModel = props.apiResult;

    if (props.apiResult.settingsCollection.productSettings) {
        const productSettings = props.apiResult.settingsCollection.productSettings;
        if (settingsModel.properties["documentIconsRootPath"]) {
            productSettings.documentIconsRootPath = settingsModel.properties["documentIconsRootPath"];
        }
    }

    if (props.apiResult.settingsCollection.cartSettings) {
        const cartSettings = props.apiResult.settingsCollection.cartSettings;
        if (settingsModel.properties["addStoredCreditCardPaymentMethod"]) {
            cartSettings.addStoredCreditCardPaymentMethod =
                settingsModel.properties["addStoredCreditCardPaymentMethod"];
        }

        if (settingsModel.properties["storedCreditCardPaymentMethod"]) {
            cartSettings.storedCreditCardPaymentMethod = settingsModel.properties["storedCreditCardPaymentMethod"];
        }
    }

    if (props.apiResult.settingsCollection.websiteSettings) {
        const websiteSettings = props.apiResult.settingsCollection.websiteSettings;
        if (settingsModel.properties["uspsAddressValidationCountryCodes"]) {
            const parsedCountryCodes = JSON.parse(settingsModel.properties["uspsAddressValidationCountryCodes"]);
            if (parsedCountryCodes) {
                websiteSettings.uspsAddressValidationCountryCodes = parsedCountryCodes;
            }
        }
    }

    if (props.apiResult.settingsCollection.accountSettings) {
        const accountSettings = props.apiResult.settingsCollection.accountSettings;
        if (settingsModel.properties["defaultCountryId"]) {
            accountSettings.defaultCountryId = settingsModel.properties["defaultCountryId"];
        }
    }
}
